import React from 'react';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/pages/Home';
import Programme from './components/pages/Programme';
import BookNow from './components/pages/BookNow';
import Kinder from './components/pages/Kinder';
import Junior from './components/pages/Junior';
import Coder from './components/pages/Coder';
import NotFound from './components/pages/NotFound'; // optional 404 page
import Contact from './components/pages/Contact'

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programme" element={<Programme />} />
          <Route path="/contact" element={<BookNow />} />
          <Route path="/book-now" element={<Contact />} />
          <Route path="/kinder" element={<Kinder />} />
          <Route path="/junior" element={<Junior />} />
          <Route path="/coder" element={<Coder />} />
          <Route path="*" element={<NotFound />} /> {/* optional 404 route */}
        </Routes>
        <a href="https://wa.me/message/XCAPPOTEII6ML1" target="_blank" rel="noreferrer" className="whatsapp-btn">
          <img src="images/whatsapp.png" alt="Whatsapp Button" />
        </a>

      </Router>
    </>
  );
}

export default App;
